import { CognitoUserPoolAndIdentityPoolConfig } from "@aws-amplify/core/dist/esm/singleton/Auth/types";

type WebsiteConfig = {
  Auth: {
    Cognito: CognitoUserPoolAndIdentityPoolConfig;
  };
};

type MultiSiteConfig = {
  internal: WebsiteConfig;
  external: WebsiteConfig;
};

export const amplifyConfig: MultiSiteConfig = {
  internal: {
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_INTERNAL_USER_POOL_ID || "",
        userPoolClientId: process.env.REACT_APP_INTERTAL_USER_POOL_WEB_CLIENT_ID || "",
        identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID || "",
        allowGuestAccess: false,
        loginWith: {
          oauth: {
            domain: process.env.REACT_APP_INTERNAL_USER_POOL_DOMAIN || "",
            scopes: ["email", "openid", "aws.cognito.signin.user.admin", "profile"],
            redirectSignIn: [process.env.REACT_APP_INTERNAL_USER_POOL_REDIRECT_URL || ""],
            redirectSignOut: [],
            responseType: "code",
          },
          username: false,
          email: false,
          phone: false,
        },
      },
    },
  },
  external: {
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || "",
        userPoolClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT_ID || "",
        identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID || "",
        allowGuestAccess: true,
        loginWith: {
          oauth: undefined,
          username: false,
          email: true,
          phone: false,
        },
        mfa: {
          status: "optional",
        },
        passwordFormat: {
          minLength: 12,
        },
        userAttributes: {
          phone_number: {
            required: true,
          },
          email: {
            required: true,
          },
        },
      },
    },
  },
};
